import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, replyId }) => {
  switch (type) {
    case drama.DELETE_DRAMA_REPLY:
      return [...state, replyId];

    case drama.DELETE_DRAMA_REPLY_SUCCESS:
    case drama.DELETE_DRAMA_REPLY_FAILED:
      return state.filter(id => id !== replyId);

    default:
      return state;
  }
}
